import { useCallback, useEffect, useState } from 'react'
import { OrderDetailResponse, OrderPhase } from '../../model'
import DefaultLoader from '../../components/Loaders/DefaultLoader'
import { NavLink, useParams, Outlet } from 'react-router-dom'
import OrderPhaseLabel from '../../components/OrderPhaseLabel/OrderPhaseLabel'
import OrderDetailHeader from '../../components/OrderDetail/OrderDetailHeader'
import TabNavLink, { TabOptionProps } from '../../components/TabNavLink/TabNavLink'
import { getOrderDetails } from '../../services/api/orders'
import DynamicFaIcon from '../../components/DynamicFaIcon/DynamicFaIcon'

const OrderDetail = () => {
    const { orderId } = useParams()
    const isAppointmentsRoute = window.location.pathname.includes('/messages')
    const [loading, setLoading] = useState<boolean>(true)
    const [order, setOrder] = useState<OrderDetailResponse | null>(null)
    // const navigate = useNavigate()

    const fetchOrder = useCallback(async () => {
        setLoading(true)
        try {
            const order = await getOrderDetails(Number(orderId))
            setOrder(order)
        } catch (e) {
            console.error(e)
        } finally {
            setLoading(false)
        }
    }, [orderId])

    useEffect(() => {
        fetchOrder()
    }, [fetchOrder])

    const options: TabOptionProps[] = [
        {
            label: 'Opleveringen',
            route: '',
            // icon: 'download',
            count: order?.unreadDeliveryCount
        },
        {
            label: 'Berichten',
            route: 'messages',
            // icon: 'message',
            count: order?.unreadMessageCount
        },
        {
            label: 'Afspraken',
            route: 'appointments'
            // icon: 'calendar'
        },
        {
            label: 'Uploads',
            route: 'uploads'
            // icon: 'upload'
        }
    ]

    const address = order?.address

    return loading ? (
        <div className='w-full flex justify-center py-4'>
            <DefaultLoader />
        </div>
    ) : (
        <>
            <div className='flex justify-between flex-col items-left my-2 flex-wrap gap-2 mb-8'>
                <div className='flex items-center'>
                    <NavLink to={'/dashboard/orders'}>
                        <DynamicFaIcon iconName='arrow-left' className='mr-2 text-[--tb-primary]' />
                        <span className='text-[--tb-textLight] font-semibold hover:underline decoration-[--tb-textLight]'>
                            Opdrachten
                        </span>
                    </NavLink>
                </div>
                {address ? (
                    <h2>
                        {address.street} {address.houseNumber}, {address.zipcode} {address.city}
                    </h2>
                ) : order?.title ? (
                    <h2>{order?.title}</h2>
                ) : null}
                {order?.phase && (
                    <div className='w-24'>
                        <OrderPhaseLabel phase={order.phase as OrderPhase} labelFirst />
                    </div>
                )}
            </div>
            <div className='p-4 flex flex-col shadow-sm space-y-4 bg-white border-full rounded-xl'>
                {order ? (
                    <OrderDetailHeader order={order} />
                ) : (
                    <div className='text-center text-gray-400 py-8'>Geen opdracht gevonden</div>
                )}
            </div>
            <div className='flex flex-col shadow-sm bg-white border-full rounded-xl mt-8'>
                <TabNavLink options={options} />
                <div
                    className={`relative min-h-[200px] lg:min-h-[500px] flex flex-col flex-grow overflow-hidden ${
                        isAppointmentsRoute ? 'max-h-[900px]' : ''
                    }`}
                >
                    <Outlet context={{ order }} />
                </div>
            </div>
        </>
    )
}

export default OrderDetail
